@import '../../../globals/main.scss';

pn-dropdown-with-multi-input-rows-row {
  .input-element-row {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;

    .input-container {
      width: 30%;

      pn-marketweb-input {
        .input-container {
          width: 100%;
        }
      }

      pn-date-picker {
        width: 100%;
      }

      .input-element-message-container {
        margin-top: 0.3rem;
        &__error {
          color: red;
          line-height: 1;
        }

        &__warning {
          line-height: 1;
        }
      }
    }
  }

  .delete-button-contianer {
    margin-top: 0.6rem;
  }

  label.pn-date-picker-label:has(span:empty) {
    display: none;
  }
}
